import { Component, OnInit, inject } from '@angular/core';
import { I18NextAdapterPipe } from '../../pipe/i18next-adapter.pipe';
import { I18nService } from '../../services/i18n.service';

@Component({
  selector: 'pfx-i18n-demo',
  imports: [I18NextAdapterPipe],
  templateUrl: './i18n-demo.component.html',
  styleUrl: './i18n-demo.component.scss',
})
export class I18nDemoComponent implements OnInit {
  private i18n = inject(I18nService);

  public ngOnInit(): void {
    this.i18n.addTranslations({
      namespace: 'i18n-demo',
      de: {
        message_one: 'Nachricht',
        message_other: 'Nachrichten',
        messageWithCount_one: '{{count}} Nachricht',
        messageWithCount_other: '{{count}} Nachrichten',
        friend: 'Freund',
        friend_male: 'Freund',
        friend_female: 'Freundin',
        friend_male_one: 'Ein Freund',
        friend_female_one: 'Eine Freundin',
        friend_male_other: '{{count}} Freunde',
        friend_female_other: '{{count}} Freundinnen',
      },
      en: {
        message_one: 'Message',
        message_other: 'Messages',
        messageWithCount_one: '{{count}} message',
        messageWithCount_other: '{{count}} messages',
        friend: 'friend',
        friend_male: 'boyfriend',
        friend_female: 'girlfriend',
        friend_male_one: 'A boyfriend',
        friend_female_one: 'A girlfriend',
        friend_male_other: '{{count}} boyfriends',
        friend_female_other: '{{count}} girlfriends',
      },
    });
  }
}
